import { render, staticRenderFns } from "./JBProposalLosses.vue?vue&type=template&id=3e87d24e"
import script from "./JBProposalLosses.vue?vue&type=script&lang=js"
export * from "./JBProposalLosses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports